import { registrationHelpers } from '@/main'

// List off vue components that needs to unread count
const instances = []

// Number of unread messages
let nb = 0

// Set nb_unread on instances
const update = () => {
  for (const instance of instances) {
    instance.nb_unread = nb
  }
}

// Init was done
let init_done = false

// Current user
let currentUser = null

// First call, load api + setup eventbus
function init($vue) {
  if (init_done) return
  init_done = true

  let timer = null
  const load = () => {
    let url = '/api/messages/count'
    if (currentUser && !registrationHelpers.userTypes.is(currentUser, 'coloc')) {
      url = `/api/messages-for-homes/${$vue.$route.params.home_id || 'default'}/count`
    }

    $vue.$http.get(url).then(
      res => {
        nb = res.data.unreaded * 1 || 0
        update()
      },
      err => console.error(err),
    )
    clearTimeout(timer)
    timer = setTimeout(load, 60 * 60 * 1000)
  }
  const reset = () => {
    nb = 0
    update()
    clearTimeout(timer)
  }
	
  // Load here, else eventBus is null
  const { eventBus } = require('@/main')

  // New message recieved
  eventBus.$on('chat:message', () => {
    nb++
    update()
  })

  // Mark some message as read
  eventBus.$on('chat:read', count => {
    nb -= count
    if (nb < 0) nb = 0
    update()
  })
	
  // Logout / login events
  eventBus.$on('noUser', reset)
  eventBus.$on('noAuthorized', reset)
  eventBus.$on('userChanged', user => {
    currentUser = user
    if (user) load()
    else reset()
  })

  // Home id changed
  $vue.$watch('$route.query.home_id', load)
}

export default {
  data: () => ({
    nb_unread: 0,
  }),
  created() {
    instances.push(this)
    init(this)
  },
  beforeDestroy() {
    const i = instances.indexOf(this)
    if (i >= 0) instances.splice(i, 1)
  },
}
